import getRandomInt from './getRandomInt';
import getCdnImg from '@/shared/cdn/getCdnImg';

const getImgSource = (img: string) =>
  /(png|jpeg|svg|jpg)$/.test(img)
    ? img
    : getCdnImg(`tournaments/bg-${getRandomInt(4)}.png`);

export default getImgSource;
